import { PageLayout } from "@/components/layout/page-layout";
import { Badge } from "@/components/ui/badge";

export default function Terms() {
  return (
    <PageLayout breadcrumbs={[{ label: "Terms of Service" }]} showCta={false}>
      <div className="mb-8">
        <Badge variant="secondary" className="mb-4">Legal</Badge>
        <h1 className="text-4xl font-extrabold tracking-tight mb-4">Terms of Service</h1>
        <p className="text-sm text-muted-foreground">Last updated: February 2025</p>
      </div>

      <div className="prose-sm max-w-3xl space-y-8">
        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">1. Acceptance of Terms</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              By accessing or using the LoadLogo API ("Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">2. Description of Service</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              LoadLogo provides a logo API service that allows users to fetch company logos, brand profiles, stock ticker logos, and cryptocurrency logos via HTTP endpoints. The Service includes a free tier and paid Pro tier.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">3. Free Tier</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              The free tier allows up to 1,000 API requests per day without requiring an API key or account creation. Free tier usage is subject to rate limiting and fair use policies.
            </p>
            <p>
              LoadLogo reserves the right to modify free tier limits or features at any time. We will provide reasonable notice of significant changes.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">4. Acceptable Use</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>You agree not to:</p>
            <ul className="list-disc list-inside space-y-1.5 pl-2">
              <li>Use the Service to distribute malware or engage in phishing</li>
              <li>Attempt to circumvent rate limits or abuse the API</li>
              <li>Scrape or bulk-download logos for redistribution</li>
              <li>Use the Service in any way that violates applicable laws or regulations</li>
              <li>Impersonate brands or use logos in a misleading manner</li>
              <li>Resell or redistribute the Service without authorization</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">5. Intellectual Property</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              Logos served through the LoadLogo API are the property of their respective brand owners. LoadLogo does not claim ownership of any third-party brand assets. The Service functions as a caching and delivery layer, similar to a CDN.
            </p>
            <p>
              The LoadLogo API, website, and documentation are the property of LoadLogo and are protected by intellectual property laws.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">6. Disclaimer of Warranties</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              The Service is provided "as is" without warranties of any kind, express or implied. LoadLogo does not guarantee that logos will be available for every domain, that the Service will be uninterrupted, or that data will be error-free.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">7. Limitation of Liability</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              LoadLogo shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service. Our total liability shall not exceed the amount you have paid for the Service in the 12 months preceding the claim.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">8. Termination</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              We may suspend or terminate your access to the Service at any time for violation of these Terms or for any other reason with reasonable notice. You may stop using the Service at any time.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">9. Changes to Terms</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the revised Terms. We will provide notice of material changes via the website or email.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">10. Contact</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              For questions about these Terms, contact us at <a href="mailto:hello@loadlogo.com" className="text-primary hover:underline">hello@loadlogo.com</a>.
            </p>
          </div>
        </section>
      </div>
    </PageLayout>
  );
}
